module.exports = __webpack_public_path__ + "static/img/icon_szh_wdfw_sjgd.92d3d698.png";